import script from "./ReturnHeaderData.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnHeaderData.vue?vue&type=script&setup=true&lang=js"

import "./ReturnHeaderData.vue?vue&type=style&index=0&id=e7c5c710&lang=css"

const __exports__ = script;

export default __exports__